import {ParticleContainer} from 'pixi.js';

import {ViewContainer} from '@specials/particle-emitter';

import {ParticleAdapter} from './ParticleAdapter';

export class ParticleContainerAdapter implements ViewContainer<ParticleAdapter> {
  constructor(private readonly container: ParticleContainer) {}

  public addChild(children: ParticleAdapter): void {
    this.container.addParticle(children.particle);
  }

  public removeChild(children: ParticleAdapter): void {
    this.container.removeParticle(children.particle);
  }
}
